import { Link } from "react-router-dom";
import Nav from "../Nav";
import Head from "../Head";

const Muestras = () => {
  window.scrollTo(0, 0);

  return (
    <>
      <Head title="Muestras" />
      <Nav titulo="Muestras" link="/" />
      <section
        id="menu"
        className="animate__fadeInDown wow animate__animated animate__delay-0s animate__slower"
      >
        <div className="cardMenu">
          <img src="../img/fotogramas/una_ramita (6).jpg" alt="Muestras" />
          <Link to={"./muestra_una_ramita"} className="boton">
            Una ramita que atraviesa el aire
          </Link>
        </div>
        <div className="cardMenu">
          <img
            src="../img/herbario_domestico/herbario_muestra (9).jpg"
            alt="Muestras"
          />
          <Link to={"./muestra_herbario_domestico"} className="boton">
            Herbario doméstico
          </Link>
        </div>
        <div className="cardMenu">
          <img src="../img/algas_y_mar/algas_y_mar (5).jpg" alt="Muestras" />
          <Link to={"./muestra_algae"} className="boton">
            Algae
          </Link>      
        </div>
      </section>
    </>
  );
};

export default Muestras;
